import React from 'react';
import {Header,Hero,Services,ProjectShowcase,ExploreServicesGrid,UniqueFeatures,HowItWorks,CTASection,Footer} from '../components/components'

const Home = () => {
  return (
    <>
    <Header/>
    <Hero/>
    <Services/>
    <ProjectShowcase/>
    <ExploreServicesGrid/>
    <UniqueFeatures/>
    <HowItWorks/>
    <CTASection/>
    <Footer/>
    </>
  )
}

export default Home